export var valuesSystemType = ["PPX", "PPN"];
/*

*/ 
//# sourceMappingURL=SystemType.js.map